import SubscribersTable from './SubscribersTable';

export default SubscribersTable;
